import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ImageCropperComponent, CropperSettings } from 'ng2-img-cropper';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-image-crop',
  templateUrl: './image-crop.component.html',
  styleUrls: ['./image-crop.component.css']
})
export class ImageCropComponent implements OnInit {
  file: any = {};
  croppedImage = new Subject<any>();
  cropperSettings: CropperSettings;


  @ViewChild('cropper', undefined) cropper: ImageCropperComponent;
  constructor(
    public dialogRef: MatDialogRef<ImageCropComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.cropperSettings = data.cropperSettings;
    this.initCrop(data.image);
    this.cropperSettings = new CropperSettings();
    this.cropperSettings.width = 300;
    this.cropperSettings.height = 250;
    this.cropperSettings.croppedWidth = 300;
    this.cropperSettings.croppedHeight = 250;
    this.cropperSettings.canvasWidth = 300;
    this.cropperSettings.canvasHeight = 250;
    this.cropperSettings.noFileInput=true;

    // this.data = {};

  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit() {
  }
  saveCroppedImage() {
    var image = "" + this.file.image;
    this.croppedImage.next(image);

  }
  closeDialog(){
    this.dialogRef.close();
  }
  initCrop(file) {
    var image: any = new Image();
    var myReader: FileReader = new FileReader();
    var that = this;
    myReader.onloadend = function (loadEvent: any) {
      image.src = loadEvent.target.result;
      that.cropper.setImage(image);
    };
    myReader.readAsDataURL(file);
  }
  getCroppedImage(){
    return this.croppedImage.asObservable();
  }

}
